module.exports = __webpack_public_path__ + "static/media/angel.fd0d6e65.svg";